import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import moment from 'moment'
import cx from 'classnames'
import {Row, Col, PageHeader, Nav, NavItem, Tooltip, OverlayTrigger} from 'react-bootstrap'
import {connectWizard, major} from '../../core/wizard'
import {linkFinder} from '../../core/links'
import extract from '../../core/extract'
import Header from '../../core/components/Header'
import CardGroup from '../../core/components/CardGroup'
import Card from '../../core/components/Card'
import Icon from '../../core/components/Icon'
import Markdown from '../../core/components/Markdown'
import TicketCallerCard from '../../ticket/components/TicketClaimCallerCard'
import TicketAddressCard from '../../ticket/components/TicketAddressCard'
import TicketAssigneeCard from '../../ticket/components/TicketAssigneeCard'
import {TicketClaim} from '../models'
import OpenTicketClaimCard from './OpenTicketClaimCard'
import QualifyTicketClaimCard from './QualifyTicketClaimCard'
import AnswerTicketClaimCard from './AnswerTicketClaimCard'
import ChallengeTicketClaimForm from './ChallengeTicketClaimForm'
import AnswerChallengeTicketClaimForm from './AnswerChallengeTicketClaimForm'
import i18n from '../i18n'
import style from './TicketClaimDetail.less'

function selectActiveStep(steps, {ticketClaim}) {
    if (!ticketClaim.uid) return 1

    switch (ticketClaim.state) {
        case 'Opened':
            return 2
        case 'Qualified':
            return 3
        case 'Answered':
            return 4
        case 'Challenged':
            return 5
        default:
            return 6
    }
}

function findState(step) {
    switch (major(step)) {
        case 2:
            return 'Opened'
        case 3:
            return 'Qualified'
        case 4:
            return 'Answered'
        case 5:
            return 'Challenged'
        case 6:
            return 'ChallengeAnswered'
    }
}

function levelToStatus(level) {
    if (level == 0) return 'success'
    if (level == 1) return 'warning'
    if (level >= 2) return 'danger'
    return 'success'
}

function entityToName(ticketClaim) {
    return (entity) => {
        switch(entity) {
            case 'CallCenter':
                return ticketClaim.callCenter.name
            case 'ClientAccount':
                return ticketClaim.clientCompany.name
            default:
                return extract(i18n.entityEnum, entity)
        }
    }
}

class TicketClaimDetail extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillMount() {
        const {ticketClaim} = this.props

        const lastCallCenterActor = TicketClaim.findLastCallCenterActor(ticketClaim)
        const lastCallCenterAction = TicketClaim.findLastCallCenterAction(ticketClaim)
        const lastClientActor = TicketClaim.findLastClientActor(ticketClaim)
        const lastClientAction = TicketClaim.findLastClientAction(ticketClaim)
        const priority = TicketClaim.findPriority(ticketClaim)
        this.setState({lastCallCenterActor, lastCallCenterAction, lastClientActor, lastClientAction, priority})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.ticketClaim != this.props.ticketClaim) {
            const {ticketClaim} = nextProps

            const lastCallCenterActor = TicketClaim.findLastCallCenterActor(ticketClaim)
            const lastCallCenterAction = TicketClaim.findLastCallCenterAction(ticketClaim)
            const lastClientActor = TicketClaim.findLastClientActor(ticketClaim)
            const lastClientAction = TicketClaim.findLastClientAction(ticketClaim)
            const priority = TicketClaim.findPriority(ticketClaim)
            this.setState({lastCallCenterActor, lastCallCenterAction, lastClientActor, lastClientAction, priority})
        }
    }

    _navigate(event, path) {
        const {dispatch} = this.props

        event.preventDefault()
        dispatch(push(path))
    }

    render() {
    	const {dispatch, ticketClaim, ticket, authenticated, wizard} = this.props
        const {lastCallCenterActor, lastCallCenterAction, lastClientActor, lastClientAction, priority} = this.state

        const status = levelToStatus(priority && priority.level)

        const stepTooltip = (step, active, disabled) => {
            const className = cx({
                'tooltip-primary': !active && !disabled,
                'tooltip-danger': active,
                'tooltip-disabled': disabled,
            })

            return (
                <Tooltip
                    className={className}>
                    {extract(i18n.stateEnum, findState(step))}
                </Tooltip>
            )
        }

        const headerHelp = () => (
            <div>
                <Icon icon='clock' size='xs' />
                <span> {moment(ticketClaim.openedAt).format(i18n.openedDateTimeFormat)} </span>
            </div>
        )

        const cardHeader = (title) => (
            <h5>{title}</h5>
        )

        const cardHeaderLarge = (title) => (
            <h3>{title}</h3>
        )

        return (
            <div className={style.default}>
                <Row>
                    <Col sm={8}>
                        {wizard.matchActiveStep(1) && (
                            <Header>
                                <h3>{i18n.newTicketClaim}</h3>
                            </Header>
                        )}
                        {wizard.matchActiveStep([2, 3, 4, 5, 6]) && (
                            <Header
                                status={status}
                                help={headerHelp()}>
                                <h3>{i18n.ticketClaim} n° {ticketClaim.ref || ticketClaim.uid}</h3>
                            </Header>  
                        )}
                        <Nav justified
                            bsStyle='progress'
                            activeKey={wizard.majorActiveStep}>
                            {[2, 3, 4, 5, 6].map((step, index) => (
                                <NavItem
                                    key={index}
                                    eventKey={step}
                                    disabled={step > wizard.activeStep}>
                                    <OverlayTrigger
                                        placement='bottom'
                                        overlay={stepTooltip(step, wizard.matchActiveStep(step), step > wizard.activeStep)}>
                                        <span
                                            className={style.step}>
                                            {step - 1}
                                        </span>
                                    </OverlayTrigger>
                                </NavItem>
                            ))}
                        </Nav>
                        {wizard.matchActiveStep([2, 3, 4, 5, 6]) && (
                            <div>
                                <div className={style.description}>
                                    <label>> {i18n.description} :</label>
                                    <Markdown markdown={ticketClaim.description} />
                                </div>
                                <Row>
                                    <Col sm={6}>
                                        <Card
                                            kind='tab'
                                            header={cardHeader(extract(i18n.stateEnum, lastClientAction) + ' ' + i18n.by)}>
                                            <h5>{lastClientActor.name}</h5>
                                            <h5>
                                                <small>{ticketClaim.clientCompany.name}</small>
                                            </h5>
                                            {ticketClaim.urgencyLevel && (
                                                <h5 className={cx(style.urgencyLevel, style[status])}>
                                                    <span>{i18n.urgencyLevel}</span>
                                                    <strong> {ticketClaim.urgencyLevel.label}</strong>
                                                </h5>
                                            )}
                                        </Card>
                                    </Col>
                                    <Col sm={6}>
                                        <Card
                                            kind='tab'
                                            position='right'
                                            header={cardHeader((extract(i18n.stateEnum, lastCallCenterAction, null) || i18n.processed) + ' ' + i18n.by)}>
                                            {lastCallCenterActor && (
                                                <div>
                                                    <h5>{lastCallCenterActor.name}</h5>
                                                    <h5>
                                                        <small>{ticketClaim.callCenter.name}</small>
                                                    </h5>
                                                </div>
                                            )}
                                            {!lastCallCenterActor && (
                                                <span>{i18n.ticketClaimNotProcessed}</span>
                                            )}
                                        </Card>
                                    </Col>
                                </Row>
                                {ticketClaim.ticketClaimQualification && (
                                    <Card
                                        header={cardHeader(i18n.qualification)}>
                                        <Row>
                                            <Col sm={6}>
                                                <h5>{i18n.category}</h5>
                                                <p>{ticketClaim.ticketClaimQualification.ticketClaimCategory.label}</p>
                                                <h5>{i18n.comment}</h5>
                                                <p><Markdown markdown={ticketClaim.ticketClaimQualification.comment}/></p>
                                            </Col>
                                            <Col sm={6}>
                                                <div className={style.metricGroup}>
                                                {ticketClaim.ticketClaimQualification.treatmentPriority && (
                                                    <div className={cx(style.metric, style[levelToStatus(ticketClaim.ticketClaimQualification.treatmentPriority.level)])}>
                                                        <p>{i18n.treatmentPriority}</p>
                                                        <div className={style.data}>
                                                            {ticketClaim.ticketClaimQualification.treatmentPriority.label}
                                                        </div>
                                                    </div>
                                                )}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card>
                                )}
                                {ticketClaim.ticketClaimAnswer && (
                                    <CardGroup>
                                        <Card
                                            header={cardHeader(i18n.postAnalysis)}>
                                            <Row>
                                                <Col sm={6}>
                                                    <h5>{i18n.postAnalysis}</h5>
                                                    <p>{ticketClaim.ticketClaimAnswer.postAnalysis.label}</p>
                                                    <h5>{i18n.failureCause}</h5>
                                                    <p>{ticketClaim.ticketClaimAnswer.failureCause.label}</p>
                                                </Col>
                                                <Col sm={6}>
                                                    <div className={style.metricGroup}>
                                                        <div className={cx(style.metric, style[levelToStatus(ticketClaim.ticketClaimAnswer.severity.level)])}>
                                                            <p>{i18n.severity}</p>
                                                            <div className={style.data}>
                                                                {ticketClaim.ticketClaimAnswer.severity.label}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={6}>
                                                    <div className={style.entity}>
                                                        <h5>{i18n.assignedEntity}</h5>
                                                        <p>{ticketClaim.ticketClaimAnswer.assignedEntities.map(entityToName(ticketClaim)).join(', ')}</p>
                                                    </div>
                                                </Col>
                                                <Col sm={6}>
                                                    <div className={style.entity}>
                                                        <h5>{i18n.accountableEntity}</h5>
                                                        <p>{ticketClaim.ticketClaimAnswer.accountableEntities.map(entityToName(ticketClaim)).join(', ')}</p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card>
                                        <Card
                                            header={cardHeader(i18n.ticketClaimAnswer)}>
                                            <Markdown markdown={ticketClaim.ticketClaimAnswer.comment}/>
                                        </Card>
                                    </CardGroup>
                                )}
                            </div>
                        )}
                        {wizard.matchActiveStep([4, 5, 6]) && (
                            <div>
                                <PageHeader>{i18n.challenge}</PageHeader>
                                {ticketClaim.ticketClaimChallenge && (
                                    <div className={style.challengeGroup}>
                                        <h5>> {ticketClaim.ticketClaimChallenge.challengedBy.name}</h5>
                                        <ul>
                                            <li>
                                                <div className={style.time}>
                                                    <Icon icon='clock' size='xs' />
                                                    <span>{moment(ticketClaim.ticketClaimChallenge.challengedAt).format(i18n.dateTimeFormat.default)}</span>
                                                </div>
                                                <div className={style.container}>
                                                    <p><Markdown markdown={ticketClaim.ticketClaimChallenge.comment}/></p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                                {ticketClaim.ticketClaimChallengeAnswer && (
                                    <div className={cx(style.challengeGroup, style.answer)}>
                                        <h5>> {ticketClaim.ticketClaimChallengeAnswer.answeredBy.name}</h5>
                                        <ul>
                                            <li>
                                                <div className={style.time}>
                                                    <Icon icon='clock' size='xs' />
                                                    <span>{moment(ticketClaim.ticketClaimChallengeAnswer.answeredAt).format(i18n.dateTimeFormat.default)}</span>
                                                </div>
                                                <div className={style.container}>
                                                    <p><Markdown markdown={ticketClaim.ticketClaimChallengeAnswer.comment}/></p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </div>
                        )}
                        {wizard.matchActiveStep(1) && (
                            <OpenTicketClaimCard />
                        )}
                        {wizard.matchActiveStep(2) && ticketClaim._links.find(linkFinder('QualifyTicketClaim')) && (
                            <QualifyTicketClaimCard />
                        )}
                        {wizard.matchActiveStep(3) && ticketClaim._links.find(linkFinder('AnswerTicketClaim')) && (
                            <AnswerTicketClaimCard />
                        )}
                        {wizard.matchActiveStep(4) && ticketClaim._links.find(linkFinder('ChallengeTicketClaim')) && (
                            <div className={cx(style.challengeGroup, style.form)}>
                                <h5>> {authenticated.firstName} {authenticated.lastName}</h5>
                                <ul>
                                    <li>
                                        <div className={style.time}>
                                            <Icon icon='clock' size='xs' />
                                            <span>{moment().format(i18n.dateTimeFormat.default)}</span>
                                        </div>
                                        <div className={style.container}>
                                            <ChallengeTicketClaimForm />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        )}
                        {wizard.matchActiveStep(5) && ticketClaim._links.find(linkFinder('AnswerChallengeTicketClaim')) && (
                            <div className={cx(style.challengeGroup, style.form, style.answer)}>
                                <h5>> {authenticated.firstName} {authenticated.lastName}</h5>
                                <ul>
                                    <li>
                                        <div className={style.time}>
                                            <Icon icon='clock' size='xs' />
                                            <span>{moment().format(i18n.dateTimeFormat.default)}</span>
                                        </div>
                                        <div className={style.container}>
                                            <AnswerChallengeTicketClaimForm />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        )}
                    </Col>
                    <Col sm={4}>
                        <div className={style.ticketHeader}>
                            <Header>
                                {ticketClaim.ticketReference.uid && ticketClaim.ticketReference.uid == (ticket && ticket.uid) && (
                                    <h3>
                                        <a
                                            href=''
                                            onClick={(e) => this._navigate(e, '/tickets/' + ticket.uid)}>
                                            <span>ticket n° {ticket.ref}</span>
                                        </a>
                                    </h3>
                                )}
                            </Header>
                        </div>
                        {ticketClaim.clientCompany && ticketClaim.agencies && (
                            <Card
                                header={cardHeaderLarge(ticketClaim.clientCompany.name)}>
                                <div className={style.company}>
                                    <p>{ticketClaim.agencies[0].name}</p>
                                </div>
                            </Card>
                        )}
                        <TicketCallerCard
                            header={cardHeaderLarge(i18n.callerIdentity)}
                            ticketIdLock={ticketClaim.ticketReference.uid || true} />
                        <TicketAddressCard
                            header={cardHeaderLarge(i18n.interventionLocation)}
                            ticketIdLock={ticketClaim.ticketReference.uid || true} />
                        <TicketAssigneeCard
                            header={cardHeaderLarge(i18n.interventionMonitoring)}
                            ticketIdLock={ticketClaim.ticketReference.uid || true} />
                    </Col>
                </Row>      
            </div>
        )
    }
}

TicketClaimDetail = connectWizard({
    activeStep: selectActiveStep
})(TicketClaimDetail)

TicketClaimDetail = connect((state) => ({
    ticketClaim: state.claim.ticketClaim,
    ticket: state.ticket.ticket,
    authenticated: state.user.authenticated
}))(TicketClaimDetail)

export default TicketClaimDetail


// WEBPACK FOOTER //
// ./lib/claim/components/TicketClaimDetail.js